module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Change your profile image":"Change your profile image"},"it":{"Change your profile image":"Cambia l\u0027immagine del tuo profilo"}}')
  delete Component.options._Ctor
}
